import Content from "./Components/Content";
import Footer from "./Components/Footer";
import { Container } from "./style";

const Finish = () => {
  return (
    <Container>
      <Content />
      <Footer />
    </Container>
  );
};

export default Finish;
